export default __webpack_public_path__ + "static/media/codeforces.3ce22f09.jpg";